/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Shortcuts_Stat_KeyboardInputs */

const tr_landing_shortcuts_stat_keyboard = /** @type {(inputs: Landing_Shortcuts_Stat_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`klavye kısayolu`)
};

const en_landing_shortcuts_stat_keyboard = /** @type {(inputs: Landing_Shortcuts_Stat_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`keyboard shortcuts`)
};

const de_landing_shortcuts_stat_keyboard = /** @type {(inputs: Landing_Shortcuts_Stat_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tastatur-Kurzbefehle`)
};

const ru_landing_shortcuts_stat_keyboard = /** @type {(inputs: Landing_Shortcuts_Stat_KeyboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`сочетаний клавиш`)
};

/**
* | output |
* | --- |
* | "keyboard shortcuts" |
*
* @param {Landing_Shortcuts_Stat_KeyboardInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_shortcuts_stat_keyboard = /** @type {((inputs?: Landing_Shortcuts_Stat_KeyboardInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Shortcuts_Stat_KeyboardInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_shortcuts_stat_keyboard(inputs)
	if (locale === "de") return de_landing_shortcuts_stat_keyboard(inputs)
	if (locale === "ru") return ru_landing_shortcuts_stat_keyboard(inputs)
	return tr_landing_shortcuts_stat_keyboard(inputs)
});